export default "__VITE_ASSET__BEDeuv5A__"